import { Navigate } from 'react-router';
import { useMe } from '../api/queries';
import { homeFor } from '../auth/flow';
import { FullPageLoader } from './FullPageLoader';

export function RootRedirect() {
  const me = useMe();
  if (me.isPending) return <FullPageLoader />;
  if (!me.data) return <Navigate to="/signin" replace />;
  return <Navigate to={homeFor(me.data.orgs)} replace />;
}
